import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  CoralResponse,
  CoralInterceptor,
  CoralRequest,
  CoralHandler,
} from '@amzn/ihm-js-coral-client';
import getCsrfToken from '@amzn/carrierlogistics-commons/dist/utils/csrf';
import {
  CSRF_TOKEN_ID,
  MONS_CUSTOMER_ID_HEADER,
  MONS_CUSTOMER_ID_SESSION,
} from '../config/requestHeaderConfig';

class RequestOptionsInterceptor extends CoralInterceptor {
  constructor(bindings = {}) {
    super();
    this.bindings = bindings;
  }

  /**
   * @param {CoralRequest} request
   * @param {CoralHandler} next
   * @returns {CoralResponse} response
   */
  // eslint-disable-next-line class-methods-use-this
  intercept(request: CoralRequest, next: CoralHandler) {
    // Adding required header
    const headers = [
      ['Accept', 'application/json'],
      ['Content-Type', 'application/json'],
      [CSRF_TOKEN_ID, getCsrfToken() ?? ''],
    ];

    const modifiedRequest = request.clone({
      headers,
      credentials: 'same-origin',
    });
    return from(next.handle(modifiedRequest)).pipe(
      map((response) => {
        const { headers: responseHeaders } = response;
        const [, monsCustomerId] = responseHeaders?.find(
          ([k]) => k === MONS_CUSTOMER_ID_HEADER
        ) ?? [MONS_CUSTOMER_ID_HEADER, ''];
        const [, csrfToken] = responseHeaders?.find(
          ([k]) => k === CSRF_TOKEN_ID
        ) ?? [CSRF_TOKEN_ID, ''];
        // Adding monsCustomerId to session storage for future reference in apis.
        sessionStorage.setItem(MONS_CUSTOMER_ID_SESSION, monsCustomerId);
        sessionStorage.setItem(CSRF_TOKEN_ID, csrfToken);
        return new CoralResponse(response);
      })
    );
  }
}

export default RequestOptionsInterceptor;
